import FpLoader from './FpLoader'
import FpLoading from './FpLoading'
export { FpLoader, FpLoading }
export default { FpLoader, FpLoading }
